import React from 'react';
import { DesBanner, MultiBanner } from './banners';
import { useUpmarketBannerVisibility } from './hooks/useUpmarketBannerVisibility';

export const UpmarketBanners = () => {
    const { withDesBanner, withMultiBanner } = useUpmarketBannerVisibility();

    if (withDesBanner) {
        return <DesBanner />;
    }

    if (withMultiBanner) {
        return <MultiBanner />;
    }

    return null;
};
